<template>

        <div>
            <vs-table :noDataText="$t('no_data_text')" ref="table" :data="ELECTRONIC_JOURNAL_HISTORY">
                <template slot="thead">
                    <vs-th sort-key="created">{{  $t("date")  }}</vs-th>
                    <vs-th sort-key="changed_by">{{  $t("changed_by")  }}</vs-th>
                    <vs-th sort-key="detail">{{  $t("Detail")  }}</vs-th>

                </template>
                <template slot-scope="{ data }">
                    <tbody>
                    <vs-tr  v-for="(item, indextr) in data" :key="indextr" :data="item">
                        <vs-td><p> {{ $moment(item.created).format('DD.MM.YYYY H:mm:ss') }} </p></vs-td>
                        <vs-td>

                            <p v-if="item.systemically"> {{ $t('systemic') }} </p>
                            <div v-else>
                                <p v-if="item.profile.full_name"> {{ item.profile.full_name }} ({{ item.profile.student_id }}) </p>
                                <!-- Если поле не заполнено, жду, что это пришло с 1С -->
                                <p v-else> {{ $t('1C') }} </p>
                            </div>


                        </vs-td>

                        <vs-td>
                            <div v-if="item.change_type === 'ELECTRONIC_JOURNAL_CHANGE'">
                                <div v-for="(key) in Object.keys(item.data)">
                                    <div v-if="key === 'student'">
                                        {{ item.data[key]  }}
                                    </div>
                                    <div v-else>
                                        <div v-if="typeof item.data[`${key}`] === 'boolean'">
                                            {{ $t(`auca_ej_history.ej_history_${key}`) }}: {{ translateBool(item.data[`${key}`]) }}
                                        </div>
                                        <div v-else>
                                            {{ $t(`auca_ej_history.ej_history_${key}`) }}: {{ item.data[`${key}`] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div v-if="item.change_type === 'CONFIGURING_CLASSES_CHANGE'">
                                 <div v-if="!Object.keys(item.data).includes('new_review_status')">
                                     {{ item.configuring_classes_date }}
                                 </div>
                                 <div v-for="(key) in Object.keys(item.data)">
                                     <div v-if="typeof item.data[`${key}`] === 'boolean'">
                                         {{ $t(`auca_ej_history.configuring_classes_${key}`) }}: {{ translateBool(item.data[`${key}`]) }}
                                     </div>
                                     <div v-else>
                                         {{ $t(`auca_ej_history.configuring_classes_${key}`) }}: {{ item.data[`${key}`] }}
                                     </div>
                                 </div>
                             </div>
                            <div v-if="item.change_type === 'DEFAULT'">
                                {{ $t(item.data.type, item.data) }}
                            </div>
                        </vs-td>


                    </vs-tr>
                    </tbody>
                </template>
            </vs-table>
        </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "ElectronicJournalHistory",
    computed:{
        ...mapGetters({
            ELECTRONIC_JOURNAL_HISTORY: 'electronic_journal/ELECTRONIC_JOURNAL_HISTORY'
        })
    },
    methods:{
        translateBool(bool) {
            if (bool) return  this.$t('Yes')
            else return this.$t('No')
        },

    }
};
</script>

<style scoped>

</style>
